import React from 'react'
import styles from './SideNav.module.scss'
import Logo from '@/components/Header/Logo'
import CollapsiblePanel from '@/components/CollapsiblePanel'
import SideModal from './components/SideModal'
import { useLocale } from 'core/components/Locale'
import { Authentication, useAuthenticate } from 'core/components/Authenticate'
import { useHCRouter } from '@/components/HCNextLink'
import LanguageAndCurrencySection from './components/LanguageAndCurrencySection'
import NotifyItem from './components/NotifyItem'
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice'
import useDefaultCoin from 'core/controller/contract/exchange/Header/useDefaultCoin'
import { panelItems as sidePanelItems } from './config'
import { useGetRewardActivityParamsQuery } from 'core/query/yapi/hk-web/Reward/query'

type SideNavProps = {
  isOpen: boolean
  onClose: () => void
}

const SideNav: React.FC<SideNavProps> = ({ isOpen, onClose }) => {
  const t = useLocale()
  const router = useHCRouter()
  const responsiveDevice = useResponsiveDevice()
  const { loginData } = useAuthenticate()
  const { perpetualPath, deliverPath } = useDefaultCoin()
  const { data: activityConfigData } = useGetRewardActivityParamsQuery()

  const handleNavigation = (item: { key: string; link: string; mLink?: string; auth?: boolean }) => {
    if (!loginData && item.auth) {
      router.push(`login`)
      return
    }

    if (item.key === 'perpetualContract') {
      item.link = `contract/exchange/trade/?tradeName=${perpetualPath}`
    }
    if (item.key === 'deliveryContract') {
      item.link = `contract/exchange/trade/?tradeName=${deliverPath}`
    }

    if (responsiveDevice === 'phone' && item.mLink) {
      router.push(item.mLink)
      return
    }
    router.push(item.link)
  }

  const panelItems = sidePanelItems.map((panel) => ({
    key: panel.key,
    className: styles.panel,
    title: (
      <div
        onClick={() => {
          if (panel.key === 'copy') {
            handleNavigation({ key: 'chargeBack', link: 'chargeBack' })
          }
        }}
        className={styles.panelTitle}
      >
        <i className={`${styles.icon} ${styles[panel.icon]}`}></i>
        <span>{t(panel.locale)}</span>
      </div>
    ),
    contentClassName: styles.panelContent,
    expandable: panel.expandable,
    children: panel.items
      .filter((item) => {
        if (
          panel.key === 'contract' &&
          item.key === 'cashback' &&
          ![1, 3].includes(activityConfigData?.data?.data?.rebateStatus ?? 0)
        ) {
          return false
        }
        return true
      })
      .map((item) => (
        <div key={item.key} onClick={() => handleNavigation(item)} className={styles.menuItem}>
          {t(item.locale)}
        </div>
      )),
  }))

  return (
    <SideModal isOpen={isOpen} onClose={onClose}>
      <div className={styles.header}>
        <div className={styles.logoWrap}>
          <div className="show-phone">
            <Logo />
          </div>
          <i onClick={onClose} className={`${styles.closeBtn} iconfont iconguanbi`}></i>
        </div>

        <Authentication
          allow={() => <></>}
          deny={({ login, register }) => (
            <div className={styles.buttons}>
              <button onClick={register} className={styles.registerBtn}>
                {t('header_009')}
              </button>
              <button onClick={login} className={styles.loginBtn}>
                {t('header_008')}
              </button>
            </div>
          )}
        />
      </div>

      <div className={styles.menuContainer}>
        <CollapsiblePanel items={panelItems} accordion={true} />

        <div className={styles.bottomItems}>
          <Authentication
            allow={() => (
              <div className={styles.navItem}>
                <NotifyItem />
              </div>
            )}
          />
          <div className={styles.navItem}>
            <LanguageAndCurrencySection />
          </div>
        </div>

        <button onClick={() => router.push('/app/downLoad')} className={styles.downloadBtn}>
          {t('hotcoinWeb_v1_1_AppDownload')}
        </button>
      </div>
    </SideModal>
  )
}

export default SideNav
